module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "confirm"
    }
  }, [(_vm.show) ? _c('div', [_c('div', {
    staticClass: "dialogbox-mask-h"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialogbox-h",
    class: [_vm.show ? 'fade-in' : 'fade-out']
  }, [_c('div', {
    staticClass: "dialogboxmain-h"
  }, [_c('div', {
    staticClass: "dialogbox-confirm-title-h"
  }, [_c('span', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-close confirm-close",
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialogbox-confirm-content-h",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "batch"
  }, [_vm._v("\n          批量处理方式："), _c('el-checkbox', {
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("批量不通过所有未处理简历")])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialogbox-confirm-footer-h"
  }, [_c('el-button', {
    attrs: {
      "plain": true,
      "type": "info"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.canceltxt))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.success(_vm.checked)
      }
    }
  }, [_vm._v(_vm._s(_vm.confirmtxt))])], 1)])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b5bb113c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfirmH/tpl.vue
// module id = 906
// module chunks = 1